import { TDrawingTool } from '../types'

export const createCursorStyle = (tool: TDrawingTool, isActive: boolean, brushSize: number): string => {
	if (!tool || !isActive) return 'default'

	// Get the canvas element that's currently being used for drawing
	const maskCanvas = document.querySelector<HTMLCanvasElement>('canvas[style*="z-index: 2"]')
	if (!maskCanvas) return 'default'

	// Calculate the scale between canvas coordinate space and display size
	const rect = maskCanvas.getBoundingClientRect()
	const scaleX = maskCanvas.width / rect.width
	const scaleY = maskCanvas.height / rect.height

	// Use the average scale to adjust the cursor size
	// When image is bigger (higher scale), cursor should appear smaller on screen
	const displayScale = (scaleX + scaleY) / 2
	const displaySize = brushSize * (1 / displayScale)

	// Create a canvas for the cursor
	const cursorSize = Math.round(displaySize)
	const canvas = document.createElement('canvas')
	const ctx = canvas.getContext('2d')
	if (!ctx) return 'default'

	// Set canvas size to accommodate the brush circle and border
	canvas.width = cursorSize + 4 // +4 for border and padding
	canvas.height = cursorSize + 4

	// Draw the circle
	ctx.beginPath()
	ctx.arc(canvas.width / 2, canvas.height / 2, cursorSize / 2, 0, Math.PI * 2)
	ctx.strokeStyle = 'white'
	ctx.lineWidth = 1.5
	ctx.stroke()

	// Create data URL for the cursor
	const dataURL = canvas.toDataURL()

	// Center the hotspot exactly in the middle of the cursor
	const hotspotOffset = Math.floor(canvas.width / 2)
	return `url(${dataURL}) ${hotspotOffset} ${hotspotOffset}, crosshair`
}
